import { clientFetch } from "./clientFetch";

// Example: Specific service for events
export const EventService = {
  getEvents: (uidCompany: string, uidCalendar: string, dateMin: string, dateMax: string) =>
    clientFetch('/v2/calendar/event/get-bulk-events', 'POST', null, { body: { company: uidCompany, uidCalendar, dateMin, dateMax } }),

  updateEvent: (data: any, company: string, calendar: string, key: string) => {
    const eventData: any = { ...data };
    if (eventData.start) eventData.start = eventData.start.replace('[America/Bogota]', '');
    if (eventData.type === 'event' || eventData.type === 'APPOINTMENT') {
      if (eventData.end) eventData.end = eventData.end.replace('[America/Bogota]', '');
    }
    return clientFetch("/v2/calendar/event/update-event", "POST", key, { 
      body: { 
        company, 
        uidCalendar: calendar, 
        uidEvent: eventData.uid,   // Firestore doc UID (string)
        event_id: eventData.id,    // Supabase numeric ID
        company_id: eventData.company_id,
        calendar_id: eventData.calendar_id,
        event: eventData,
        operators: eventData.responsible ? [eventData.responsible.id] : undefined,
        participants: eventData.participants ? eventData.participants.map((p: any) => p.id) : undefined
      } 
    });
  },

  createEvent: (data: any, company: string, calendar: string, key: string) => {
    const eventData: any = { ...data };
    if (eventData.start) eventData.start = eventData.start.replace('[America/Bogota]', '');
    if (eventData.type === 'event' || eventData.type === 'APPOINTMENT') {
      if (eventData.end) eventData.end = eventData.end.replace('[America/Bogota]', '');
    }
    
    // Ensure all numeric IDs are present at root as required by logic-free driver
    return clientFetch("/v2/calendar/event/create-event", "POST", key, { 
      body: { 
        company, 
        uidCalendar: calendar, 
        company_id: eventData.company_id,
        calendar_id: eventData.calendar_id,
        event: eventData,
        operators: eventData.responsible ? [eventData.responsible.id] : [],
        participants: (eventData.participants || []).map((p: any) => p.id)
      } 
    });
  },

  deleteEvent: (uidCompany: string, uidCalendar: string, event: string) =>
    clientFetch(`/v1/delete_event`, "POST", null, { 
      body: { 
        companyId: uidCompany, 
        calendarId: uidCalendar, 
        eventId: event 
      } 
    }),
};
